import { createContext, useContext } from "react";

interface TableExpandContextValue {
  expanded: Set<string>;
  onToggle: (key: string) => void;
  indexOffsets?: Record<string, number>;
}

const TableExpandContext = createContext<TableExpandContextValue | null>(null);

export const TableExpandProvider = TableExpandContext.Provider;

export function useTableExpand(): TableExpandContextValue | null {
  return useContext(TableExpandContext);
}
